import component from './chart.vue'

export default component
